module.exports = __webpack_public_path__ + "img/project_9.1b7ad1c4.png";